// src/features/stock/hooks/useStockCategories.js
import { useState, useEffect } from 'react';
import toast from 'react-hot-toast';
import stockApi from '../services/stockApi';

export const useStockCategories = () => {
  const [categories, setCategories] = useState([]);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    fetchCategories();
  }, []);

  const fetchCategories = async () => {
    setLoading(true);
    try {
      const response = await stockApi.getStockCategories();
      setCategories(response.data);
    } catch (err) {
      toast.error('Failed to fetch categories');
    } finally {
      setLoading(false);
    }
  };

  const createCategory = async (data) => {
    try {
      const response = await stockApi.createStockCategory(data);
      toast.success('Category created successfully');
      fetchCategories();
      return response.data;
    } catch (err) {
      toast.error(err.response?.data?.message || 'Failed to create category');
      throw err;
    }
  };

  const getCategoryName = (categoryId) => {
    const category = categories.find(c => c.id === categoryId);
    return category?.name || 'Unknown';
  };

  return {
    categories,
    loading,
    createCategory,
    getCategoryName,
  };
};